import { useRouter } from 'next/router';

const EarlyExit = ({ Component, condition, ...rest }) => {
  const router = useRouter();

  if (condition) {
    return null;
  }

  return <Component router={router} {...rest} />;
};

export default EarlyExit;
